.valuesList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacingSm);
}

.placeholder {
  color: var(--paletteBlue2);
}
